import { FC } from 'react';
import ItemButton from 'src/components/common/ItemButton';
import useResponsive from 'src/hooks/contexts/useResponsive';
import { StyledArrowContainer, StyledArrowImage } from './ArrowButton.styles';
import { IArrowButton } from './ArrowButton.type';

const ArrowButton: FC<IArrowButton> = ({
	direction,
	isDisabled = false,
	isHidden = false,
	onClick,
	arrowClassName,
	...otherProps
}) => {
	const { isSmallerThanMd } = useResponsive();

	return (
		<StyledArrowContainer
			direction={direction}
			isDisabled={isDisabled}
			isHidden={isHidden}
			arrowClassName={arrowClassName}
			{...otherProps}
		>
			<StyledArrowImage
				src={`/assets/divers/single-page-arrow${isSmallerThanMd ? '-mobile' : ''}.svg`}
				alt={`go to ${direction}`}
			/>

			<ItemButton onClick={!isDisabled ? onClick : undefined} />
		</StyledArrowContainer>
	);
};

export { ArrowButton };
